import { createRequestInterceptor } from '../createInterceptor'

export const tokenInterceptor = createRequestInterceptor(({ noToken }) => (config) => {
  const token = localStorage.getItem('token')
  if (!noToken && token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
